import { useMemo } from 'react';

import type { User } from '@/interfaces/app.interfaces';

import CompanyDetailsActionBar from '../../action-bar/CompanyDetailsActionBar';
import { NoCompanySelectedPanel, CompanySelectedPanel } from '../../panels';

import useSettingsStore from '../../../store/useSettingsStore';

import * as styles from './CompanyDetailsTab.css';

type Props = {
  user: User;
};

export default function CompanyDetailsTab({ user }: Props) {
  const selectedCompany = useSettingsStore((state) => state.selectedCompany);

  const companyId = useMemo(() => user.company?.id ?? selectedCompany?.id, [user.company?.id, selectedCompany?.id]);

  return (
    <div className={styles.root}>
      <CompanyDetailsActionBar user={user} />
      {!companyId ? <NoCompanySelectedPanel /> : <CompanySelectedPanel companyId={companyId} />}
    </div>
  );
}
